import { z } from 'zod';

export const taricSearchSchema = z.object({
  commodityCode: z
    .string()
    .trim()
    .min(1, 'Please enter a valid numeric code.')
    .regex(/^\d+$/, 'Please enter numbers only.'),
});
